import React, { memo, useState, useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import TypeWriter from './TypeWriter';
import Button0AI from '../../../../components/Button/Button0AI/Button0AI';
import {
  aigcReplysWritingEnd,
  aigcReplyWritingStop,
  aigcReplyIsBusing,
  aigcShowDialog,
  aigcGetReplys,
  aigcReplysZanDao,
  aigcShowMessage,
} from '../../../../actions/aigc';
import { CONTEXT } from '../../../../config';
import { logging, logPostInfo } from '../../../../actions/log';

const selectInstalledSoft = createSelector(
  state => state.native,
  native => native.installedSoft,
);

const selectUpgradeSofts = createSelector(
  state => state.native,
  native => native.upgradeSofts,
);

const selectIsEnabledSilent = createSelector(
  state => state.layout,
  layout => layout.isEnabledSilent,
);

const selectSilentInstSoft = createSelector(
  state => state.native,
  native => native.supportSilentInstSoft,
);

const selectIsBusing = createSelector(
  state => state.aigc,
  aigc => aigc.isBusing,
);
const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default memo(
  ({
    styles,
    answerIndex,
    answerItem = {},
    answerIndexShow,
    showOperate = false,
    h5IDAll,
    start = () => {},
    reAnswerback = () => {},
    userText,
    reAnswerShow,
  }) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const upgradeSofts = useSelector(selectUpgradeSofts); // 可更新
    const installedSofts = useSelector(selectInstalledSoft); // 已经安装
    const isEnabledSilent = useSelector(selectIsEnabledSilent); // 是否打开快速静默安装
    const silentInstSoft = useSelector(selectSilentInstSoft); // 支持快速静默安装的应用列表
    const likeNode = useRef(null);
    const dislikeNode = useRef(null);
    const [stopTag, setStopTag] = useState(false);
    const isBusing = useSelector(selectIsBusing);
    const logInfoData = useSelector(selectLogInfo);

    const handlePauseText = data => {
      dispatch(aigcReplyWritingStop({ h5IDAll, h5ID: answerItem?.h5ID, ...data }));
      dispatch(aigcReplyIsBusing({ isBusing: 4 }));
    };

    useEffect(() => {
      answerItem?.commandMsg?.appList.forEach((item, i) => {
        let param3 = {};
        try {
          param3 = JSON.parse(item?.bizInfo);
        } catch (e) {
          param3 = {};
        }
        dispatch(
          logging({
            category: 'I',
            action: 'Search_Aigc_AppShow',
            label: '',
            param2: {
              softid: item?.softID,
              search_word: userText,
            },
            param3: param3,
          }),
        );
      });
    }, []);

    useEffect(() => {
      if (isBusing === 4) {
        setStopTag(true);
      }
    }, [isBusing]);

    const handleEvaluate = opt => {
      let left = '';
      let right = '';
      let param3 = {};
      try {
        param3 = JSON.parse(answerItem?.bizInfo);
      } catch (e) {
        param3 = {};
      }
      if (opt === '1') {
        if (answerItem?.isZan) {
          left = false;
        } else {
          left = true;
          if (answerItem?.isDao) {
            right = false;
          }
        }
        dispatch(
          logging({
            category: 'C',
            action: 'Search_Aigc_Satisfy',
            label: '',
            param2: {
              search_word: userText,
            },
            param3: param3,
          }),
        );
      } else {
        if (answerItem?.isDao) {
          right = false;
        } else {
          right = true;
          if (answerItem?.isZan) {
            left = false;
          }
        }
        dispatch(
          logging({
            category: 'C',
            action: 'Search_Aigc_NoSatisfy',
            label: '',
            param2: {
              search_word: userText,
            },
            param3: param3,
          }),
        );
      }
      dispatch(
        aigcReplysZanDao({
          h5IDAll,
          h5ID: answerItem?.h5ID,
          isZan: left,
          isDao: right,
        }),
      );
    };

    const handleReAnswer = () => {
      let param3 = {};
      try {
        param3 = JSON.parse(answerItem?.bizInfo);
      } catch (e) {
        param3 = {};
      }
      dispatch(
        logging({
          category: 'C',
          action: 'Search_Aigc_Recall',
          label: '',
          param2: {
            search_word: userText,
          },
          param3: param3,
        }),
      );

      dispatch(
        aigcGetReplys({
          isReAnswer: true,
          reAnswer: {
            h5IDAll,
            h5ID: answerItem?.h5ID,
          },
        }),
      );
      reAnswerback();
    };

    const showText = soft => {
      let isSilentSoft = false;
      let isInstall = installedSofts.find(
        soft_ =>
          soft_.androidType !== '1' &&
          (soft_.softID === soft.softID || soft_.SoftID === soft.softID),
      );

      let isUpgrade = upgradeSofts.find(
        soft_ =>
          soft_.androidType !== '1' &&
          (soft_.softID === soft.softID || soft_.SoftID === soft.softID),
      );

      if (silentInstSoft && isEnabledSilent) {
        isSilentSoft = silentInstSoft.find(soft_ => soft_.softID === soft.softID);
      }
      if (isUpgrade) {
        return '升级';
      } else if (isInstall) {
        return '打开';
      } else if (isSilentSoft && isEnabledSilent) {
        return '快装';
      } else {
        return '安装';
      }
    };

    const answerback = () => {
      if (!stopTag) {
        dispatch(aigcReplysWritingEnd({ h5IDAll, h5ID: answerItem?.h5ID }));
        dispatch(aigcReplyIsBusing({ isBusing: 5 }));
      }
    };

    const handleJump = (info, index) => {
      dispatch(
        logging({
          category: 'C',
          action: 'Search_Aigc_View',
          label: '',
          param2: {
            softid: info?.softID,
            search_word: userText,
          },
          param3: {
            ...JSON.parse(info?.bizInfo),
          },
        }),
      );
      dispatch(
        logPostInfo({
          source_p: `AIGC_${logInfoData.source}`,
          source_pp: logInfoData.source_p,
        }),
      );
      history.push(`${CONTEXT}/detail/soft/${info.softID}/${info.bizInfo || '{}'}`);
      dispatch(aigcShowDialog(false));
    };

    const handleInfo = soft => {
      if (soft?.payType === 1) {
        return true;
      } else {
        if (soft?.appBizType !== 0) {
          return true;
        } else {
          if (soft?.sourceInfo) {
            return true;
          } else {
            return false;
          }
        }
      }
    };

    return (
      <>
        {answerItem?.writing === 2 && (
          <>
            <TypeWriter
              node={`${
                answerIndexShow ? `<span class=${styles.chat_index}>回答${answerIndex}</span> ` : ``
              }
        <span class="info_title">${answerItem?.commandMsg?.tip}</span>
        ${answerItem?.commandMsg?.appList
          .map(
            (softEl, softIndex) =>
              `<div class="info_soft_item_w" key=${softIndex}>
            <span>
              ${
                answerItem?.commandMsg?.appList?.length > 1 ? `<span>${softIndex + 1}、</span>` : ``
              }
              <span class='info_soft_name'>${softEl?.softName}: </span>
              ${softEl?.introduction}
            </span>
            ${
              softEl?.storeApp === 1
                ? `${
                    handleInfo(softEl)
                      ? `<span>
                ${softEl?.softName}不支持直接下载，请点击进入
                <span class=${styles.soft_operate} handle-data='task'>应用详情</span> 后操作
              </span>`
                      : `<span>
                您可以点击 <span class=${styles.soft_operate} handle-data='writing'>${showText(
                          softEl,
                        )}</span> 或者点击
                <span class=${styles.soft_operate}  handle-data='writing' >查看详情</span>
              </span>`
                  }`
                : ``
            }
            
            
          </div>`,
          )
          .join('')}`}
              answerCallback={answerback}
              startCallback={() => {
                start();
              }}
              controlStop={stopTag}
              stopCallback={data => handlePauseText(data)}
            />
          </>
        )}
        {answerItem?.writing === 3 && (
          <>
            {answerIndexShow && <span className={styles.chat_index}>回答{answerIndex}</span>}{' '}
            <span className="info_title">{answerItem?.commandMsg?.tip}</span>
            {answerItem?.commandMsg?.appList.map((softEl, softIndex) => (
              <div className="info_soft_item" key={softIndex}>
                <span>
                  {answerItem?.commandMsg?.appList?.length > 1 && (
                    <span>{`${softIndex + 1}、`} </span>
                  )}
                  <span className="info_soft_name"> {`${softEl?.softName}:`}</span>{' '}
                  <span dangerouslySetInnerHTML={{ __html: softEl?.introduction }} />{' '}
                </span>
                {softEl?.storeApp === 1 && (
                  <span>
                    {handleInfo(softEl) ? (
                      <span>
                        {softEl?.softName}不支持直接下载，请点击进入{' '}
                        <span
                          className={styles.soft_operate}
                          onClick={() => handleJump(softEl, softIndex + 1)}
                        >
                          应用详情
                        </span>{' '}
                        后操作
                      </span>
                    ) : (
                      <span>
                        您可以点击{' '}
                        <span className={styles.soft_operate}>
                          <Button0AI soft={softEl} logInfo={{ search_word: userText }} />
                        </span>{' '}
                        或者点击{' '}
                        <span
                          className={styles.soft_operate}
                          onClick={() => handleJump(softEl, softIndex + 1)}
                        >
                          {' '}
                          查看详情{' '}
                        </span>
                      </span>
                    )}
                  </span>
                )}
              </div>
            ))}
            <div className="info_operate">
              {showOperate && reAnswerShow && answerItem.canFresh && (
                <div className="re_answer" onClick={handleReAnswer}>
                  <i className="iconfont icon-ai_chongxinhuida" /> 重新回答
                </div>
              )}

              <div className="evaluate">
                <div className="icon_left">
                  <i
                    className={`iconfont icon-ai_xihuan ${
                      answerItem?.isZan ? styles.i_active : ''
                    }`}
                    ref={likeNode}
                    onClick={() => handleEvaluate('1')}
                  />
                  <div className="icon_left_desc">喜欢</div>
                </div>
                <div className="icon_right">
                  <i
                    className={`iconfont icon-ai_buxihuan ${
                      answerItem?.isDao ? styles.i_active : ''
                    }`}
                    ref={dislikeNode}
                    onClick={() => handleEvaluate('2')}
                  />
                  <div className="icon_right_desc">不喜欢</div>
                </div>
              </div>
            </div>
          </>
        )}
        {answerItem?.writing === 4 && (
          <>
            {answerIndexShow && <span className={styles.chat_index}>回答{answerIndex}</span>}{' '}
            <span className="info_title">{answerItem?.commandMsg?.tip}</span>
            {answerItem?.commandMsg?.appList.map((softEl, softIndex) => (
              <div className="info_soft_item" key={softIndex}>
                <span>{softEl?.pauseDesc}</span>
              </div>
            ))}
            <div className="info_operate">
              {showOperate && reAnswerShow && answerItem.canFresh && (
                <div className="re_answer" onClick={handleReAnswer}>
                  <i className="iconfont icon-ai_chongxinhuida" /> 重新回答
                </div>
              )}

              <div className="evaluate">
                <div className="icon_left">
                  <i
                    className={`iconfont icon-ai_xihuan ${
                      answerItem?.isZan ? styles.i_active : ''
                    }`}
                    ref={likeNode}
                    onClick={() => handleEvaluate('1')}
                  />
                  <div className="icon_left_desc">喜欢</div>
                </div>
                <div className="icon_right">
                  <i
                    className={`iconfont icon-ai_buxihuan ${
                      answerItem?.isDao ? styles.i_active : ''
                    }`}
                    ref={dislikeNode}
                    onClick={() => handleEvaluate('2')}
                  />
                  <div className="icon_right_desc">不喜欢</div>
                </div>
              </div>
            </div>
          </>
        )}
      </>
    );
  },
);
